import { useEffect, useRef, useState } from 'react'
import type { Overlay } from '../view-api'

/** Reuse CoreEditor's upload boundary for file-picker, paste and drop alike. */
export const FilePicker: Overlay = ({ api }) => {
  const input = useRef<HTMLInputElement>(null)
  const [accept, setAccept] = useState('')
  useEffect(() => {
    const root = api.root
    if (!root) return () => {}
    const open = (event: Event) => {
      if (!(event instanceof CustomEvent)) return
      const accept = event.detail === 'image' ? 'image/*' : event.detail === 'video' ? 'video/*' : ''
      setAccept(accept)
      if (input.current) { input.current.accept = accept; input.current.click() }
    }
    root.addEventListener('core-view-insert-files', open)
    return () => { root.removeEventListener('core-view-insert-files', open) }
  }, [api.root])
  return <input ref={input} type="file" multiple hidden accept={accept} aria-label="Insert files"
    data-testid="content-blocks-editor-file-input" onChange={event => {
      const files = event.currentTarget.files
      if (!files?.length || !api.root) return
      const data = new DataTransfer()
      for (const file of files) data.items.add(file)
      api.root.dispatchEvent(new ClipboardEvent('paste', { bubbles: true, cancelable: true, clipboardData: data }))
      event.currentTarget.value = ''
    }} />
}
